// app/javascript/controllers/pflegegrad_rechner_controllers/carousel_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["carousel", "prev", "next"];

  connect() {
    // bind once so we can remove later
    this._updateButtons = () => this.updateButtons();
    // Width of one card on ≥ lg screens (≈ w-80 + gap)
    this.itemWidth = 320;
    // Initial button state & listeners
    this.updateButtons();
    this.carouselTarget.addEventListener("scroll", this._updateButtons);
    window.addEventListener("resize", this._updateButtons);
  }
    
  disconnect() {
    this.carouselTarget.removeEventListener("scroll", this._updateButtons);
    window.removeEventListener("resize", this._updateButtons);
  }

  /* actions -------------------------------------------------------------- */

  scrollPrev() {
    this.carouselTarget.scrollBy({
      left: -this.scrollAmount(),
      behavior: "smooth",
    });
  }

  scrollNext() {
    this.carouselTarget.scrollBy({
      left: this.scrollAmount(),
      behavior: "smooth",
    });
  }

  /* helpers -------------------------------------------------------------- */

  scrollAmount() {
    const container = this.carouselTarget.clientWidth;
    const items = Math.floor(container / this.itemWidth);
    return Math.max(1, items) * this.itemWidth;
  }

  updateButtons() {
    // Hide nav on mobile
    if (window.innerWidth < 1024) {
      if (this.hasPrevTarget) this.prevTarget.style.opacity = "0";
      if (this.hasNextTarget) this.nextTarget.style.opacity = "0";
      if (this.hasPrevTarget) this.prevTarget.style.pointerEvents = "none";
      if (this.hasNextTarget) this.nextTarget.style.pointerEvents = "none";
      return;
    }

    const { scrollLeft, scrollWidth, clientWidth } = this.carouselTarget;
    const maxScroll = scrollWidth - clientWidth;

    if (this.hasPrevTarget) {
      this.prevTarget.style.opacity = scrollLeft <= 0 ? "0.3" : "1";
      this.prevTarget.style.pointerEvents = scrollLeft <= 0 ? "none" : "auto";
    }

    if (this.hasNextTarget) {
      const atEnd = scrollLeft >= maxScroll - 15;
      this.nextTarget.style.opacity = atEnd ? "0.3" : "1";
      this.nextTarget.style.pointerEvents = atEnd ? "none" : "auto";
    }
  }
}